<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <button class="all-btn add-btn pull-right" @click="addAnalog" v-if="comparison.analogs.length < 4">Аналог қўшиш</button>
                        <div class="pull-right mr-5 mt-2" v-if="comparison.exchangeRate && comparison.exchangeRate > 0">
                            1 USD = {{comparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{comparison.exchangeRateDate}})
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                                <div class="table-wrapper">
                                  <table class="table table-striped comparison-table" :style="`min-width: ${1100 + comparison.analogs.length * 130}px`">
                                      <tr>
                                          <th rowspan="2">Таккослаш элементлари</th>
                                          <th rowspan="2" class="text-center">Таккослаш объекти</th>
                                          <th v-if="comparison.analogs.length > 0" :colspan="comparison.analogs.length" class="text-center">
                                              Таккослаш объекти (аналоги)
                                          </th>
                                      </tr>
                                      <tr>
                                          <th class="text-center" v-for="(analog, index) in comparison.analogs" :key="index" style="position: relative">
                                              аналог {{index + 1}}
                                              <i class="fa fa-remove red"
                                                 style="position: absolute;right: 3px;top: 3px;cursor: pointer"
                                                 @click="removeAnalog(index)"></i>
                                           <template v-if="isApiLookUp">
                                               <v-select
                                                       :options="uyJoyAnalogs"
                                                       label="name"
                                                       :filterable="false"
                                                       v-model="analog.apiAnalog"
                                                       @change="onApiAnalogChange"
                                                       :clearable="false"
                                               >
                                                   <template slot="option" slot-scope="option" v-if="option && option.name">
                                                       <div v-html="option.name" style="font-weight: bold"></div>
                                                       <template v-if="option.variations">
                                                           <template v-for="field in option.variations">
                                                               <template v-if="field.code === 'area_all'">
                                                                   <div class="text-dark" :key="field.id">
                                                                       <span>{{field.label}} : {{field.value}}</span>
                                                                   </div>
                                                               </template>
                                                           </template>
                                                           <template>
                                                               <div class="text-dark">
                                                                   <span>{{option.price | currency('', 2, { thousandsSeparator: ' ' })}} {{option.priceUnit.symbol}}</span>
                                                               </div>
                                                           </template>
                                                       </template>
                                                   </template>
                                                   <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                               </v-select>
                                           </template>
                                          </th>
                                      </tr>
                                      <tr>
                                          <td>Сотилиш бахоси. АКШ доллар</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <numeric-input v-model="analog.price.usd" :precision="2" align="center"
                                                             @input="calculateUZS(analog)"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].price.usd.$error}"
                                                             :disabled="isApiLookUp"
                                              />
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Сотилиш бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <numeric-input v-model="analog.price.uzs" :precision="2" align="center"
                                                             @input="calculateUSD(analog)"
                                                             :class="{invalid : $v.comparison.analogs.$each[index].price.uzs.$error}"
                                                             :disabled="isApiLookUp"
                                              />
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Фойдаланилган маълумотлар манбаи</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index">
                                              <input type="text" class="form-control" v-model="analog.source" style="text-align: center"
                                                     :class="{invalid : $v.comparison.analogs.$each[index].source.$error}"
                                                     :disabled="isApiLookUp"
                                              />
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар киритиш</i></td>
                                          <td :colspan="comparison.analogs.length + 1" class="text-center">
                                              Таккослаш аналоглардан баҳоланаётган объектга нисбатан
                                          </td>
                                      </tr>
                                      <template v-if="isApiLookUpResidential || isApiLookUpNotResidential || !sectionType">
                                          <!--AREA UNIT FIX-->
                                          <tr class="section-start">
                                              <td>Умумий қурилиш ости майдони (м2)</td>
                                              <td class="text-center">
                                                  <!--{{ area | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                                  <numeric-input v-model="comparison.area" :precision="2" align="center"
                                                                 :class="{invalid : $v.comparison.area.$error}"/>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index">
                                                  <numeric-input v-model="analog.area" :precision="2" align="center"
                                                                 :class="{invalid : $v.comparison.analogs.$each[index].area.$error}" :disabled="isApiLookUp"/>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатиш коэффицентлари</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.area" :defaultValue="true" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.areaFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>
                                      <template>
                                          <!-- EVL GROUND AREA FIX-->
                                          <tr class="section-start">
                                              <td>Умумий майдони (м2)</td>
                                              <td class="text-center">
                                                  <!--{{ area | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                                  <numeric-input v-model="comparison.evlGroundArea" :precision="2" align="center"/>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index">
                                                  <numeric-input v-model="analog.evlGroundArea" :precision="2" align="center" :disabled="isApiLookUp"/>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатиш коэффицентлари</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.evlGroundArea" :defaultValue="true" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.evlGroundAreaFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>
                                      <template v-if="!isApiLookUp">
                                          <!--OWNERSHIP RIGHT FIX-->
                                          <tr class="section-start">
                                              <td>Берилаётган эгалик хукуки</td>
                                              <td>
                                                  <select class="form-control" v-model="comparison.ownershipRight">
                                                      <option :value="option.code"
                                                              v-for="option in ref.ownershipRights" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <select class="form-control" v-model="analog.ownershipRight">
                                                      <option :value="option.code"
                                                              v-for="option in ref.ownershipRights" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.ownershipRight" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.ownershipRightFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>

                                      <!--FINANCIAL CONDITIONS FIX-->
                                     <!-- <tr class="section-start">
                                          <td>Молиявий шартлари</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.financialCondition">
                                                  <option :value="option.code"
                                                          v-for="option in ref.financialConditions" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.financialCondition">
                                                  <option :value="option.code"
                                                          v-for="option in ref.financialConditions" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.financialCondition" :precision="2" align="center" :allow-negative="true"/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.financialConditionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr> -->

                                      <!--TERMS OF SALE FIX-->
                                      <tr class="section-start">
                                          <td>Сотилиш шартлари</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.termsOfSale">
                                                  <option :value="option.code"
                                                          v-for="option in ref.termsOfSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.termsOfSale" :disabled="isApiLookUp">
                                                  <option :value="option.code"
                                                          v-for="option in ref.termsOfSales" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <select class="form-control" v-model="analog.fix.termsOfSale">
                                                      <option :value="option" v-for="option in analog.termsOfSaleOptions" :key="option">{{option}}</option>
                                                  </select>
                                                  <!--<numeric-input v-model="analog.fix.termsOfSale" :precision="2" align="center" :allow-negative="true"/>-->
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.termsOfSaleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                     <template v-if="!isApiLookUp">
                                         <!--NEGOTIATION PRICE CHANGE FIX-->
                                         <tr class="section-start">
                                             <td>Савдолашиш пайтидаги сотилиш бахосини пасайиши</td>
                                             <!-- <td class="text-center">
                                                  Сотилиш қиймати
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  Таклиф бахоси
                                              </td> -->
                                         </tr>
                                         <tr>
                                             <td><i>Тузатишлар</i></td>
                                             <td class="text-center">%</td>
                                             <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                 <div class="percentage">
                                                     <!--<numeric-input v-model="analog.fix.negotiation" :precision="2" align="center" :allow-negative="true"/>-->
                                                     <select class="form-control" align="center" :allow-negative="true" v-model="analog.fix.negotiation">
                                                         <option :value="option"
                                                                 v-for="option in analog.negotiationFixOptions"
                                                                 :key="option">
                                                             {{option}}
                                                         </option>
                                                     </select>
                                                     <span>%</span>
                                                 </div>
                                             </td>
                                         </tr>
                                         <tr>
                                             <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                             <td></td>
                                             <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                 {{calculated.analogs[index].price.negotiationFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                             </td>
                                         </tr>
                                     </template>
                                      <!--SALES DATE FIX-->
                                      <tr class="section-start">
                                          <td>Савдога қуйиш/Сотиш санаси</td>
                                          <td class="text-center">
                                              (жорий)
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <datepicker class="form-control" format="dd/MM/yyyy" v-model="calculated.analogs[index].salesDatePicked" :clear-button="true"
                                                          :disabled="isApiLookUp"
                                                          :disabledDates="model.disabledDates"
                                              ></datepicker>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.salesDate" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.salesDateFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--REGIONAL FIX-->
                                    <!--  <tr class="section-start">
                                          <td>Жойлашган жойи</td>
                                          <td>
                                              <div class="text-center" v-if="region && region.parent && region.parent.label">{{region.parent.label}}</div>
                                              <div class="text-center" v-if="region && region.label">{{region.label}}</div>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <treeselect class="form-control" v-model="analog.region" :multiple="false" placeholder="Танланг..." :options="ref.provinces"></treeselect>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.region" :precision="2" align="center" :allow-negative="true"/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr> -->

                                      <!--AUTO TRANSPORT PLACE STATE FIX-->
                                      <template v-if="!isApiLookUp">
                                          <tr class="section-start">
                                              <td>Автотранспорт тураргоҳи</td>
                                              <td>
                                                  <select class="form-control"
                                                          v-model="comparison.autoTransportPlaceState">
                                                      <option :value="option.code"
                                                              v-for="option in ref.autoTransportPlaceState"
                                                              :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index"
                                                  class="text-center">
                                                  <select class="form-control" v-model="analog.autoTransportPlaceState">
                                                      <option :value="option.code"
                                                              v-for="option in ref.autoTransportPlaceState"
                                                              :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index"
                                                  class="text-center">
                                                  <div class="percentage">
                                                      <select class="form-control"
                                                              v-model="analog.fix.autoTransportPlaceState"
                                                              v-if="comparison.autoTransportPlaceState !== analog.fix.autoTransportPlaceState">
                                                          <option :value="option"
                                                                  v-for="option in analog.autoTransportPlaceStateOptions"
                                                                  :key="option">{{option}}
                                                          </option>
                                                      </select>
                                                      <!--<numeric-input v-model="analog.fix.autoTransportPlaceState" :precision="2" align="center" :allow-negative="true"/>-->
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index"
                                                  class="text-center">
                                                  {{calculated.analogs[index].price.autoTransportPlaceStateFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>

                                      <!--ENGINEERING COMMUNICATION FIX-->
                                      <tr class="section-start">
                                          <td>Инженерлик комуникациялар</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.engineerCommunication">
                                                  <option :value="option.code"
                                                          v-for="option in ref.engineerCommunications" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.engineerCommunication" :disabled="isApiLookUp">
                                                  <option :value="option.code"
                                                          v-for="option in ref.engineerCommunications" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.engineerCommunication" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.engineerCommunicationFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <template v-if="isApiLookUpNotResidential || isApiLookUpMultiStorey || !isApiLookUp">
                                          <!--FLOOR FIX-->
                                          <tr class="section-start">
                                              <td>Қаватлилиги</td>
                                              <td class="text-center">
                                                  <numeric-input v-model="comparison.floor" :precision="2" align="center"/>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage" style="width: 150px !important;">
                                                      <numeric-input v-model="analog.floor" :precision="0" align="center" :disabled="isApiLookUp"/>
                                                      <span>қават</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.floor" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.floorFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>

                                      <template v-if="!isApiLookUp">
                                          <!--AUTO TRANSPORT PLACE CLOSENESS FIX-->
                                          <tr class="section-start">
                                              <td>Автотранспортларнинг қатнов йўлига яқинлиги</td>
                                              <td>
                                                  <select class="form-control" v-model="comparison.autoTransportPlaceCloseness">
                                                      <option :value="option.code" v-for="option in ref.autoTransportPlaceCloseness" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <select class="form-control" v-model="analog.autoTransportPlaceCloseness">
                                                      <option :value="option.code" v-for="option in ref.autoTransportPlaceCloseness" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.autoTransportPlaceCloseness" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.autoTransportPlaceClosenessFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>

                                      <!--CONSTRUCTIVE ELEMENTS FIX-->
                                      <tr class="section-start">
                                          <td>Конструктив элементлар (Девор)</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.constructiveElements">
                                                  <option :value="option.code" v-for="option in ref.constructiveElements" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.constructiveElements" :disabled="isApiLookUp">
                                                  <option :value="option.code" v-for="option in ref.constructiveElements" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.constructiveElements" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.constructiveElementsFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <!--REPAIR CONDITION FIX-->
                                      <tr class="section-start">
                                          <td>Таъмир холати</td>
                                          <td>
                                              <select class="form-control" v-model="comparison.repairCondition">
                                                  <option :value="option.code" v-for="option in ref.repairConditions" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <select class="form-control" v-model="analog.repairCondition" :disabled="isApiLookUp">
                                                  <option :value="option.code" v-for="option in ref.repairConditions" :key="option.code">
                                                      {{option.label}}
                                                  </option>
                                              </select>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td><i>Тузатишлар</i></td>
                                          <td class="text-center">%</td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              <div class="percentage">
                                                  <numeric-input v-model="analog.fix.repairCondition" :precision="2" align="center" :allow-negative="true" readonly/>
                                                  <span>%</span>
                                              </div>
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{calculated.analogs[index].price.repairConditionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                      <template v-if="isApiLookUp">
                                          <!--MADE YEAR FIX-->
                                          <tr class="section-start">
                                              <td>Қурилган йили</td>
                                              <td class="text-center">
                                                  <numeric-input v-model="comparison.madeYear" :precision="0" align="center"/>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage" style="width: 150px !important;">
                                                      <numeric-input v-model="analog.madeYear" :precision="0" align="center"
                                                                     :disabled="isApiLookUp"
                                                                     :max="maxMadeYear"
                                                      />
                                                      <span>йил</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.madeYear" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.madeYearFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>
                                      <template v-if="isApiLookUpNotResidential">
                                          <!--RAILWAY FIX-->
                                          <tr class="section-start">
                                              <td>Темир йўл тармоғи</td>
                                              <td>
                                                  <select class="form-control" v-model="comparison.railway">
                                                      <option :value="option.code"
                                                              v-for="option in ref.railways" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <select class="form-control" v-model="analog.railway"
                                                          :disabled="isApiLookUp">
                                                      <option :value="option.code"
                                                              v-for="option in ref.railways" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.railway" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.railwayFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>

                                      <template v-if="isApiLookUpMultiStorey">
                                          <!--ELEVATOR FIX-->
                                          <tr class="section-start">
                                              <td>Лифт</td>
                                              <td>
                                                  <select class="form-control" v-model="comparison.elevator">
                                                      <option :value="option.code"
                                                              v-for="option in ref.elevators" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <select class="form-control" v-model="analog.elevator"
                                                          :disabled="isApiLookUp">
                                                      <option :value="option.code"
                                                              v-for="option in ref.elevators" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.elevator" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.elevatorFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>

                                      <template v-if="!isApiLookUp">
                                          <!-- CHANGEABILITY TO OTHER ACTIVITY FIX-->
                                          <tr class="section-start">
                                              <td>Бошка фаолиятга узгартириш кулайлиги</td>
                                              <td>
                                                  <select class="form-control" v-model="comparison.activityChangeability">
                                                      <option :value="option.code"
                                                              v-for="option in ref.activityChangeabilityTypesBuilding" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <select class="form-control" v-model="analog.activityChangeability">
                                                      <option :value="option.code"
                                                              v-for="option in ref.activityChangeabilityTypesBuilding" :key="option.code">
                                                          {{option.label}}
                                                      </option>
                                                  </select>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td><i>Тузатишлар</i></td>
                                              <td class="text-center">%</td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  <div class="percentage">
                                                      <numeric-input v-model="analog.fix.activityChangeability" :precision="2" align="center" :allow-negative="true" readonly/>
                                                      <span>%</span>
                                                  </div>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Тузатиш киритилган кейинги бахоси. Сум</td>
                                              <td></td>
                                              <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                                  {{calculated.analogs[index].price.activityChangeabilityFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </template>
                                      <!--ТУЗАТИШЛАР МИКДОРИ-->
                                      <!--<tr class="section-start">-->
                                          <!--<td>Тузатишлар суммаси</td>-->
                                          <!--<td></td>-->
                                          <!--<td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">-->
                                              <!--{{analog.fixedPercentTotal}} %-->
                                          <!--</td>-->
                                      <!--</tr>-->
                                      <tr>
                                          <td>Оралик курсаткичлари</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.middleParam | currency('', 3, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>кофф. Улушлари</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.coefficientShare | currency('', 3, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr>
                                          <td>Тузатишларни киритгандан кейинги улушларни хисобга олгандаги бахоси</td>
                                          <td></td>
                                          <td v-for="(analog, index) in comparison.analogs" :key="index" class="text-center">
                                              {{analog.totalFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td>Объектнинг қиймати (1м2 учун)</td>
                                          <td class="text-center" :colspan="comparison.analogs.length + 1">
                                              {{calculated.calculatedObjectTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>
                                      <tr class="bold-row">
                                          <td>Жами йиғиндиси</td>
                                          <td class="text-center" :colspan="comparison.analogs.length + 1">
                                              {{calculated.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                          </td>
                                      </tr>

                                  </table>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
   // import Treeselect from '@riophae/vue-treeselect';
    import {formatDate, parseDate} from '@/shared/utils';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    import {required, requiredUnless, minValue, minLength, maxLength} from 'vuelidate/lib/validators';
    import {calculateAnalogFixed} from '../../shared/calcApproachesAnalogFixes'

    export default {
        name: "RealEstateBuildingComparisonView",
        components: {
            Datepicker
           // Treeselect
        },
        data() {
            return {
                processing: false,
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                realEstateId: ((this.$route.params.hasOwnProperty('realEstateId') && this.$route.params.realEstateId) ? this.$route.params.realEstateId : null),
                buildingId: ((this.$route.params.hasOwnProperty('buildingId') && this.$route.params.buildingId) ? this.$route.params.buildingId : null),
                name: '',
                region: null,
                comparison: {
                    exchangeRate: null,
                    exchangeRateDate: null,
                    area: 0,
                    ownershipRight: 'permanent',
                    financialCondition: 'market',
                    termsOfSale: 'contract',
                    autoTransportPlaceState: 'exists',
                    engineerCommunication: 'exists',
                    floor: null,
                    autoTransportPlaceCloseness: 'high',
                    constructiveElements: 'brick_baked',
                    repairCondition: 'good',
                    activityChangeability: 'accommodation',
                    calculatedTotalPrice: 0,
                    analogs: [],
                    evlGroundArea: 0,
                    madeYear: 0,
                    railway: 'non_exists',
                    elevator: 'non_exists'
                },
                ref: {
                    ...COMPARISON_REFERENCES,
                    provinces: []
                },
                createDate: null,
                sectionResId: null,
                uyJoyAnalogs: [],
                sectionType: null,
                maxMadeYear: new Date().getFullYear(),
                confirmedDate: null,
                model: {
                    disabledDates:{}
                }
            }
        },
        validations() {
            return {
                comparison: {
                    area: {
                        required: requiredUnless(() => {
                            return !!(this.isApiLookUpMultiStorey)
                        })
                    },
                    analogs: {
                        required: required,
                        minLength: minLength(3),
                        maxLength: maxLength(5),
                        $each: {
                            source: {
                                required: required
                            },
                            area: {
                                required: requiredUnless(() => {
                                    return !!(this.isApiLookUpMultiStorey)
                                })
                            },
                            price: {
                                usd: {
                                    required: required,
                                    minValue: minValue(0.01)
                                },
                                uzs: {
                                    required: required,
                                    minValue: minValue(0.01)
                                }
                            }
                        }
                    }
                }
            }
        },
        computed: {
            calculated() {
                let fixedPercentTotalAll = 0;
                this.comparison.analogs.forEach((analog) => {

                    if (this.comparison.autoTransportPlaceState === 'non_exists' && analog.autoTransportPlaceState === 'exists') {
                        analog.autoTransportPlaceStateOptions = [-5, -10, -15];
                        if (analog.fix.autoTransportPlaceState >= 0) {
                            analog.fix.autoTransportPlaceState = -5;
                        }
                    } else if (this.comparison.autoTransportPlaceState === 'exists' && analog.autoTransportPlaceState === 'non_exists') {
                        analog.autoTransportPlaceStateOptions = [5, 10, 15];
                        if (analog.fix.autoTransportPlaceState <= 0) {
                            analog.fix.autoTransportPlaceState = 5;
                        }
                    } else {
                        analog.autoTransportPlaceStateOptions = [0];
                        analog.fix.autoTransportPlaceState = 0;
                    }

                    if (this.comparison.termsOfSale === 'non_contract' && analog.termsOfSale === 'contract') {
                        analog.termsOfSaleOptions = [-5, -10, -15];
                        if (analog.fix.termsOfSale >= 0) {
                            analog.fix.termsOfSale = -5;
                        }
                    } else if (this.comparison.termsOfSale === 'contract' && analog.termsOfSale === 'non_contract') {
                        analog.termsOfSaleOptions = [5, 10, 15];
                        if (analog.fix.termsOfSale <= 0) {
                            analog.fix.termsOfSale = 5;
                        }
                    } else {
                        analog.termsOfSaleOptions = [0];
                        analog.fix.termsOfSale = 0;
                    }

                    analog.negotiationFixOptions = [0, -5, -10, -15];

                    // fix
                    analog.fix.area = this.calculateFixArea(this.comparison.area, analog.area);
                    analog.fix.ownershipRight = calculateAnalogFixed.calculateFixOwnerShipRights(this.comparison.ownershipRight,analog.ownershipRight);
                    analog.fix.salesDate = calculateAnalogFixed.calculateFixSalesDate(analog.salesDatePicked, analog.createDate);
                    analog.fix.engineerCommunication = calculateAnalogFixed.calculateFixEngineerCommunication(this.comparison.engineerCommunication,analog.engineerCommunication);
                    analog.fix.floor = calculateAnalogFixed.calculateFixFloor(this.comparison.floor, analog.floor);
                    analog.fix.autoTransportPlaceCloseness = calculateAnalogFixed.calculateFixAutoTransportPlaceCloseness(this.comparison.autoTransportPlaceCloseness,analog.autoTransportPlaceCloseness);
                    analog.fix.constructiveElements = calculateAnalogFixed.calculateFixConstructiveElements(this.comparison.constructiveElements,analog.constructiveElements);
                    analog.fix.repairCondition = calculateAnalogFixed.calculateFixRepairConditions(this.comparison.repairCondition, analog.repairCondition);
                    analog.fix.activityChangeability = calculateAnalogFixed.calculateFixEconomicClassifications(this.comparison.activityChangeability, analog.activityChangeability);
                    analog.fix.evlGroundArea = (this.comparison.evlGroundArea && this.comparison.evlGroundArea > 0) ? this.calculateFixGroundArea(this.comparison.evlGroundArea, analog.evlGroundArea) : -10;
                    analog.fix.madeYear = calculateAnalogFixed.calculateFixMadeYear(this.comparison.madeYear, analog.madeYear);
                    analog.fix.railway = calculateAnalogFixed.calculateFixRailwayAndElevator(this.comparison.railway, analog.railway);
                    analog.fix.elevator = calculateAnalogFixed.calculateFixRailwayAndElevator(this.comparison.elevator, analog.elevator);

                    // price
                    analog.price.areaFixed = this.calculateAreaFixed(analog.price.uzs, analog.area, analog.fix.area);

                    if (this.isApiLookUpMultiStorey) {
                        analog.price.evlGroundAreaFixed = this.calculateAreaFixed(analog.price.uzs,analog.evlGroundArea,analog.fix.evlGroundArea);
                    } else {
                        analog.price.evlGroundAreaFixed = this.calculateFixed(analog.price.areaFixed,analog.fix.evlGroundArea);
                    }

                    analog.price.ownershipRightFixed = this.calculateFixed(analog.price.evlGroundAreaFixed, analog.fix.ownershipRight);
                    analog.price.financialConditionFixed = this.calculateFixed(analog.price.ownershipRightFixed, analog.fix.financialCondition);
                    analog.price.termsOfSaleFixed = this.calculateFixed(analog.price.ownershipRightFixed, analog.fix.termsOfSale);
                    analog.price.negotiationFixed = this.calculateFixed(analog.price.termsOfSaleFixed, analog.fix.negotiation);
                    analog.price.salesDateFixed = this.calculateFixed(analog.price.negotiationFixed, analog.fix.salesDate);
                    analog.price.regionFixed = this.calculateFixed(analog.price.salesDateFixed, analog.fix.region);
                    analog.price.autoTransportPlaceStateFixed = this.calculateFixed(analog.price.salesDateFixed, analog.fix.autoTransportPlaceState);
                    analog.price.engineerCommunicationFixed = this.calculateFixed(analog.price.autoTransportPlaceStateFixed, analog.fix.engineerCommunication);
                    analog.price.floorFixed = this.calculateFixed(analog.price.engineerCommunicationFixed, analog.fix.floor);
                    analog.price.autoTransportPlaceClosenessFixed = this.calculateFixed(analog.price.floorFixed, analog.fix.autoTransportPlaceCloseness);
                    analog.price.constructiveElementsFixed = this.calculateFixed(analog.price.autoTransportPlaceClosenessFixed, analog.fix.constructiveElements);
                    analog.price.repairConditionFixed = this.calculateFixed(analog.price.constructiveElementsFixed, analog.fix.repairCondition);
                    analog.price.madeYearFixed = this.calculateFixed(analog.price.repairConditionFixed, analog.fix.madeYear);
                    analog.price.railwayFixed = this.calculateFixed(analog.price.madeYearFixed, analog.fix.railway);
                    analog.price.elevatorFixed = this.calculateFixed(analog.price.railwayFixed, analog.fix.elevator);
                    analog.price.activityChangeabilityFixed = this.calculateFixed(analog.price.elevatorFixed, analog.fix.activityChangeability);

                    let fixedPercentTotal = 0;
                    Object.keys(analog.fix).forEach((key) => {
                        if (analog.fix[key] && analog.fix[key] !== 0) {
                            fixedPercentTotal = fixedPercentTotal + parseInt(analog.fix[key]);
                        }
                    });
                    analog.fixedPercentTotal = (fixedPercentTotal >= 0 ? fixedPercentTotal : (0 - fixedPercentTotal));
                    // analog.fixedPercentTotal = fixedPercentTotal;
                    fixedPercentTotalAll += analog.fixedPercentTotal;
                    // analog.middleParam = analog.fixedPercentTotal >= 1 ? (1 / analog.fixedPercentTotal) : 1;
                    //
                    // let middleParamTotal = 0;
                    // this.comparison.analogs.forEach((function (item) {
                    //     if (item.middleParam) {
                    //         middleParamTotal += item.middleParam;
                    //     }
                    // }));
                    // if (middleParamTotal && middleParamTotal > 0) {
                    //     analog.coefficientShare = (analog.middleParam / middleParamTotal);
                    // } else {
                    //     analog.coefficientShare = 0;
                    // }
                    // analog.totalFixed = analog.price.activityChangeabilityFixed * analog.coefficientShare;
                });

                let middleParamTotal = 0;
                this.comparison.analogs.forEach((function (analog) {
                    if (fixedPercentTotalAll > 0) {
                        analog.middleParam = 1 - (analog.fixedPercentTotal / fixedPercentTotalAll);
                    } else {
                        analog.middleParam = 1;
                    }
                    middleParamTotal += analog.middleParam;
                }));

                this.comparison.analogs.forEach((function (analog) {
                    analog.coefficientShare = analog.middleParam / middleParamTotal;
                    analog.totalFixed = analog.price.activityChangeabilityFixed * analog.coefficientShare;
                }));

                let calculatedTotalPrice = 0;
                this.comparison.analogs.forEach((function (analog) {
                    if (analog.totalFixed) {
                        calculatedTotalPrice += analog.totalFixed;
                    }
                }));

                return {
                    analogs: this.comparison.analogs,
                    calculatedTotalPrice: this.isApiLookUpMultiStorey ? calculatedTotalPrice * this.comparison.evlGroundArea : calculatedTotalPrice * this.comparison.area,
                    calculatedObjectTotalPrice: calculatedTotalPrice
                }
            },
            isApiLookUp() {
                return !!(this.sectionType && this.sectionType === 'ResidentialIndividual' || this.sectionType === 'ResidentialMultiStorey' || this.sectionType === 'NotResidential');
            },
            isApiLookUpResidential() {
                return (this.sectionType && this.sectionType === 'ResidentialIndividual');
            },
            isApiLookUpNotResidential() {
                return (this.sectionType && this.sectionType === 'NotResidential');
            },
            isApiLookUpMultiStorey() {
                return (this.sectionType && this.sectionType === 'ResidentialMultiStorey');
            }
        },
        methods: {
            init() {
                const vm = this;
                this.$http.get('real-estate/building/comparison/' + this.buildingId)
                    .then(res => {
                        // header
                        vm.createDate = res.data.createDate;
                        vm.name = res.data.name;
                        // vm.area = res.data.area;
                        vm.region = res.data.region;
                        vm.ref.provinces = res.data.provinces;

                        if (res.data.sectionType) {
                            vm.sectionType = res.data.sectionType;
                        }
                        // comparisons
                        let comparison = res.data.comparison;
                        if (!comparison) {
                            comparison = {};
                        }
                        if (!(comparison.area && comparison.area > 0)) {
                            comparison.area = res.data.area;
                        }
                        if (!comparison.analogs) {
                            comparison.analogs = [];
                        }
                        if (comparison.analogs && comparison.analogs.length > 0) {
                            comparison.analogs.forEach((analog) => {
                                analog.salesDatePicked = parseDate(analog.salesDate);
                                analog.createDate = vm.createDate;
                            });
                        }
                        vm.comparison = comparison;
                        while (vm.comparison.analogs.length < 3) {
                            this.addAnalog();
                        }
                        if (res.data && res.data.confirmedDate)  {
                            vm.confirmedDate = res.data.confirmedDate;
                            vm.model.disabledDates['from'] = parseDate(vm.confirmedDate);
                        }

                        const filterData = {
                            category: res.data.sectionResId,
                            regionCode: res.data.region.code,
                            variations: {
                                source_date: {
                                    value:  vm.confirmedDate
                                }
                            }
                        };

                        this.initUyJoyAnalogApi(filterData);
                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.comparison.analogs.forEach((analog) => {
                    analog.salesDate = formatDate(analog.salesDatePicked);
                });
                this.comparison.calculatedTotalPrice = this.calculated.calculatedTotalPrice;
                this.$http.post('real-estate/building/comparison/' + this.buildingId, this.comparison)
                    .then(res => {
                        console.log(res.data);
                        this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });
            },
            addAnalog() {
                if (this.comparison.analogs.length < 4) {
                    this.comparison.analogs.push({
                        source: '',
                        area: 0,
                        salesDatePicked: new Date(),
                        region: null,
                        createDate: this.createDate,
                        price: {
                            usd: 0,
                            uzs: 0,
                            areaFixed: null,
                            ownershipRightFixed: null,
                            financialConditionFixed: null,
                            termsOfSaleFixed: null,
                            negotiationFixed: null,
                            salesDateFixed: null,
                            regionFixed: null,
                            autoTransportPlaceStateFixed: null,
                            engineerCommunicationFixed: null,
                            floorFixed: null,
                            autoTransportPlaceClosenessFixed: null,
                            constructiveElementsFixed: null,
                            repairConditionFixed: null,
                            activityChangeabilityFixed: null,
                            evlGroundAreaFixed: null,
                            madeYearFixed: null,
                            railwayFixed: null,
                            elevatorFixed: null
                        },
                        fix: {
                            area: 0,
                            ownershipRight: 0,
                            financialCondition: 0,
                            termsOfSale: 0,
                            negotiation: 0,
                            salesDate: 0,
                            region: 0,
                            autoTransportPlaceState: 0,
                            engineerCommunication: 0,
                            floor: 0,
                            autoTransportPlaceCloseness: 0,
                            constructiveElements: 0,
                            repairCondition: 0,
                            activityChangeability: 0,
                            evlGroundArea: 0,
                            madeYear: 0,
                            railway: 0,
                            elevator: 0
                        },
                        ownershipRight: 'permanent',
                        financialCondition: 'market',
                        termsOfSale: 'contract',
                        autoTransportPlaceState: 'exists',
                        engineerCommunication: 'exists',
                        floor: null,
                        autoTransportPlaceCloseness: 'high',
                        constructiveElements: 'brick_baked',
                        repairCondition: 'good',
                        activityChangeability: 'accommodation',
                        fixedPercentTotal: 0,
                        middleParam: 1,
                        coefficientShare: 0,
                        totalFixed: 0,
                        evlGroundArea: 0,
                        apiAnalog: null,
                        madeYear: 0,
                        railway: 'non_exists',
                        elevator: 'non_exists'
                    });
                }
            },
            removeAnalog(index) {
                this.comparison.analogs.splice(index, 1);
            },
            calculateUSD(analog) {
                if (analog.price.uzs && this.comparison && this.comparison.exchangeRate > 0) {
                    analog.price.usd = analog.price.uzs / this.comparison.exchangeRate;
                } else {
                    analog.price.usd = 0;
                }
            },
            calculateUZS(analog) {
                if (analog.price.usd && this.comparison && this.comparison.exchangeRate > 0) {
                    analog.price.uzs = analog.price.usd * this.comparison.exchangeRate;
                } else {
                    analog.price.uzs = 0;
                }
            },
            calculateFixed(value, fixPercentage) {

                if (value && fixPercentage && fixPercentage !== 0) {
                    return value + value * (fixPercentage / 100);
                } else {
                    return value;
                }
            },
            calculateAreaFixed(value,area,fixPercentage){
                value = value / area;

                if (value && fixPercentage && fixPercentage !== 0) {
                    return value + (value * fixPercentage) / 100;
                } else {
                    return value;
                }
            },
            calculateFixArea (compArea, analogArea) {
                if ((analogArea - compArea >= 50) && (Math.abs(analogArea - compArea) <= 200)) {
                    return -5;
                } else if ((compArea - analogArea >= 50) && (compArea - analogArea <= 200)) {
                    return 5;
                } else if (analogArea - compArea >= 201 && analogArea - compArea < 400) {
                    return -10;
                } else if (compArea - analogArea >= 201 && compArea - analogArea < 400) {
                    return 10;
                } else if (analogArea - compArea >= 401) {
                    return -15;
                } else if (compArea - analogArea >= 401) {
                    return 15
                } else return 0.000;
            },
            calculateFixGroundArea(compGroundArea, analogGroundArea) {
                if ((analogGroundArea - compGroundArea >= 50) && (Math.abs(analogGroundArea - compGroundArea) < 120)) {
                    return -3;
                } else if ((compGroundArea - analogGroundArea >= 50) && (compGroundArea - analogGroundArea < 120)) {
                    return 3;
                } else if (analogGroundArea - compGroundArea >= 120 && analogGroundArea - compGroundArea <= 200) {
                    return -6;
                } else if (compGroundArea - analogGroundArea >= 120 && compGroundArea - analogGroundArea <= 200) {
                    return 6;
                } else if (analogGroundArea - compGroundArea > 200 && analogGroundArea - compGroundArea <= 300) {
                    return -9;
                } else if (compGroundArea - analogGroundArea > 200 && compGroundArea - analogGroundArea <= 300) {
                    return 9
                } else if (analogGroundArea - compGroundArea > 300) {
                    return -9;
                } else if (compGroundArea - analogGroundArea > 300) {
                    return 9;
                } else return 0.000;
            },
            initUyJoyAnalogApi(filter) {
                const vm = this;
                this.uyJoyAnalogs = [];
                this.$http.post('/uy-joy-api/analogs',filter)
                    .then(res => {
                        console.log(res.data);
                        vm.uyJoyAnalogs = res.data.data
                    }, err => {
                       console.log(err)
                    });
            },
            onApiAnalogChange() {
                this.comparison.analogs.forEach((analog) => {
                    if (analog.apiAnalog && analog.apiAnalog !== null) {

                        if (analog.apiAnalog.priceUnit.code === 'UZS') {
                            analog.price.uzs = analog.apiAnalog.price;
                            this.calculateUSD(analog)
                        } else if (analog.apiAnalog.priceUnit.code === 'USD') {
                            analog.price.usd = analog.apiAnalog.price;
                            this.calculateUZS(analog)
                        }

                        analog.apiAnalog.variations.forEach((field) => {
                            if (field.code === 'source') {
                                analog.source = field.valueLabel;
                            }
                            if (field.code === 'building_width_area') {
                                analog.area = parseFloat(field.value);
                            }
                            if (field.code === 'area_all') {
                                analog.evlGroundArea = parseFloat(field.value);
                            }
                            if (field.code === 'terms_of_sale') {
                                analog.termsOfSale = field.value
                            }
                            if (field.code === 'source_date') {
                                analog.salesDatePicked = parseDate(field.value)
                            }
                            if (field.code === 'engineer_communications') {
                                if (field.values) {
                                    if (field.values.length >= 6 && !field.values.includes('does_not_exist')) {
                                        analog.engineerCommunication = 'all'
                                    } else if (field.values.length < 6 && !field.values.includes('does_not_exist')) {
                                        analog.engineerCommunication = 'some'
                                    } else {
                                        analog.engineerCommunication = 'non_exists'
                                    }
                                } else {
                                    analog.engineerCommunication = 'non_exists'
                                }
                            }
                            if (field.code === 'floors_building') {
                                analog.floor = parseInt(field.value)
                            }
                            if (field.code === 'type_of_building') {
                                analog.constructiveElements = field.value;
                            }
                            if (field.code === 'repair_status') {
                                analog.repairCondition = field.value;
                            }
                            if (field.code === 'year_construction_delivery') {
                                analog.madeYear = parseInt(field.value)
                            }
                            if (field.code === 'railway') {
                                analog.railway = field.value
                            }
                            if (field.code === 'elevator') {
                                analog.elevator = field.value
                            }
                        });

                    }
                });
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
